import { create } from 'zustand';
import { persist } from 'zustand/middleware';
const applyTheme = (theme) => {
    if (typeof document === 'undefined')
        return;
    const root = document.documentElement;
    const wantDark = theme === 'dark' ||
        (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    root.classList.toggle('dark', wantDark);
};
export const useThemeStore = create()(persist((set) => ({
    theme: 'system',
    setTheme: (t) => { applyTheme(t); set({ theme: t }); },
}), {
    name: 'arshe.theme',
    onRehydrateStorage: () => (state) => { if (state)
        applyTheme(state.theme); },
}));
// Re-apply theme when the OS preference flips, if we're in "system" mode.
if (typeof window !== 'undefined') {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
        const { theme } = useThemeStore.getState();
        if (theme === 'system')
            applyTheme('system');
    });
}
